var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: "100%",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0492 19.7237C22.0492 24.7513 18.0085 28.827 13.0244 28.827C8.04024 28.827 3.99927 24.7504 3.99927 19.7237C3.99927 14.697 8.03993 10.6201 13.0244 10.6201C18.0088 10.6201 22.0492 14.6961 22.0492 19.7237Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.9494 19.7237C31.9494 24.4561 29.9291 28.294 27.4369 28.294C24.9447 28.294 22.9243 24.4561 22.9243 19.7237C22.9243 14.9912 24.9443 11.1533 27.4366 11.1533C29.9288 11.1533 31.9491 14.99 31.9491 19.7237",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.9981 19.7236C35.9981 23.9627 35.2876 27.4012 34.411 27.4012C33.5344 27.4012 32.8242 23.9636 32.8242 19.7236C32.8242 15.4836 33.5347 12.0459 34.411 12.0459C35.2873 12.0459 35.9981 15.4832 35.9981 19.7236Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.3d3cc6c1a59c836e4f33793c95b18e64.svg";
export { ForwardRef as ReactComponent };